import { IApplicationState } from '../../types/redux';
import { getDiscounts } from './getDiscounts';

export function getDiscountById(state: IApplicationState, id: number) {
  const discounts = getDiscounts(state);

  return discounts.find(discount => discount.id === id) || null;
}
